import { render } from "./WorkspaceSettings.vue?vue&type=template&id=1244ff20&scoped=true"
import script from "./WorkspaceSettings.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettings.vue?vue&type=script&lang=js"

import "./WorkspaceSettings.vue?vue&type=style&index=0&id=1244ff20&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1244ff20"]])

export default __exports__